import styled from 'styled-components';
import { key } from 'styled-theme';

const InputWrap = styled.div<{
  rounded?: boolean;
  leftPadded?: boolean;
  size?: string;
  showOptions?: boolean;
  handleOptionsShowing?: boolean;
}>`
  position: relative;

  .Select {
    font-size: 17px;
    border: 0;
  }

  .Select-control {
    border-radius: ${(props: { rounded?: boolean }) =>
      props.rounded ? '10px' : '0'} !important;
    border-color: #b1b8c0 !important;
  }

  & + * .Select-control {
    border-top: 0;
  }

  .Select-first {
    .Select-control {
      border-radius: 10px 10px 0 0 !important;
    }
  }

  .Select-last {
    .Select-control {
      border-radius: 0 0 10px 10px !important;
    }
  }

  ${(props: { size?: string }) => `
    .Select-control, .Select-input {
      height: ${props.size};
    }

    .Select-placeholder, .Select--single > .Select-control .Select-value {
      line-height: ${props.size};
    }
  `};

  ${(props: { size?: string }) =>
    props.size === '48px'
      ? `
    .Select-input > input {
      padding: 12px 0 15px;
    }
  `
      : ''};

  ${(props: { leftPadded?: boolean }) =>
    props.leftPadded
      ? `
    .Select-placeholder, .Select--single > .Select-control .Select-value, .Select-input {
      padding-left: 40px;
    }
  `
      : ''};

  .Select.is-focused {
    .Select-control {
      box-shadow: inset 0 0 8px 0 ${key('global.primary')},
        inset 0 0 0 1px ${key('global.primary')};
      .Select-input:focus {
        background: none;
      }
    }
  }

  .Select.is-open {
    ~ .Select-menu-error {
      display: none;
    }
  }

  .Select-menu-outer {
    margin-top: 7px;
    background: #ffffff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    font-size: 16px;
    overflow: hidden;
    display: ${(props: {
      handleOptionsShowing?: boolean;
      showOptions?: boolean;
    }) => {
      if (props.handleOptionsShowing) {
        return props.showOptions ? 'block' : 'none';
      }

      return 'initial';
    }};
  }

  .Select-arrow-zone {
    width: 50px;
  }

  .VirtualizedSelectOption {
    cursor: pointer;
    flex-direction: row;
    justify-content: space-between;
  }

  .VirtualizedSelectFocusedOption {
    background: ${key('colors.blue.light[100]')};
  }
`;

export default InputWrap;
